(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.product-list-show-more-wrapper').forEach(function (wrapper) {
      var initialVisible = parseInt(wrapper.getAttribute('data-initial-visible'), 10) || 3;
      var sectionEl = wrapper.closest('[data-testid="product-list"]');
      var toggleBtn = sectionEl ? sectionEl.querySelector('.product-list-show-more__toggle') : null;
      var toggleWrap = sectionEl ? sectionEl.querySelector('.product-list-show-more__toggle-wrap') : null;
      var items = wrapper.querySelectorAll('.resource-list__item');

      if (!items.length) return;

      var isMobile = window.innerWidth < 768;

      if (isMobile) {
        // 모바일: 아이템 인라인 스타일 초기화, 버튼 숨김
        items.forEach(function (item) { item.style.display = ''; });
        wrapper.removeAttribute('data-expanded');
        if (toggleWrap) toggleWrap.style.display = 'none';
      } else {
        // PC: 첫 N개만 표시, 버튼 표시
        wrapper.setAttribute('data-expanded', 'false');
        items.forEach(function (item, idx) {
          item.style.display = idx < initialVisible ? 'block' : 'none';
        });
        if (toggleWrap) toggleWrap.style.display = '';

        if (toggleBtn && !toggleBtn.dataset.bound) {
          toggleBtn.dataset.bound = 'true';
          toggleBtn.addEventListener('click', function () {
            var isExpanded = wrapper.getAttribute('data-expanded') === 'true';
            if (!isExpanded) {
              items.forEach(function (item) { item.style.display = 'block'; });
              wrapper.setAttribute('data-expanded', 'true');
              toggleBtn.textContent = 'close';
              toggleBtn.setAttribute('aria-expanded', 'true');
            } else {
              items.forEach(function (item, idx) {
                item.style.display = idx < initialVisible ? 'block' : 'none';
              });
              wrapper.setAttribute('data-expanded', 'false');
              toggleBtn.textContent = 'more';
              toggleBtn.setAttribute('aria-expanded', 'false');
            }
          });
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
